import axios, { AxiosError } from "axios";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

import { IndexPageData, MenuItem } from "@/store/indexPage/interfaces";
import { IPageMeta } from "@/services/interfaces/";

import { DataDefault, MetaDefault } from "./enums";

@Module({
  name: "index",
  namespaced: true,
})
export default class IndexModule extends VuexModule {
  data: IndexPageData = DataDefault;
  meta: IPageMeta = MetaDefault;

  get getData() {
    return this.data;
  }
  get getMeta() {
    return this.meta;
  }
  get getContacts() {
    return this.data.contacts;
  }

  @Mutation
  setIndexMetaData(meta: IPageMeta) {
    this.meta = Object.assign({}, MetaDefault, meta);
  }

  @Mutation
  setSaleCount(count: number) {
    this.meta = Object.assign({}, this.meta, { on_sale_new_items_count: count });
  }

  @Mutation
  setMenu(menu: MenuItem) {
    this.meta = Object.assign({}, this.meta, { menu: menu });
  }

  @Mutation
  setIndexPageData(data: IndexPageData) {
    this.data = Object.assign({}, DataDefault, data);
  }

  @Action
  async requestData(): Promise<void> {
    try {
      const res = await axios({
        method: "GET",
        url: "/api/index",
      });
      if (res.data?.data) this.setIndexPageData(res.data?.data);
      if (res.data?.meta) this.setIndexMetaData(res.data?.meta);
    } catch (err) {
      const Error = err as AxiosError;
      console.warn(Error.message);
    }
  }
}
